import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useEffect, useState } from "react";
import styles from "../../../styles/tables.module.scss";

import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Empty } from "../../components/Empty";
import { Input } from "../../components/Input";
import { Label } from "../../components/Label";
import { Loading } from "../../components/Loading";
import { Icon } from "../../components/core/Icon";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { QRCode } from "../../tools/QRCode";

dayjs.extend(duration);

export default function EcleticaTables({ tables, loadTables }) {
  const [state, setState] = useState({
    visible: false,
    loading: true,
    qrcodeImage: "",
    open: false,
    selectedTable: null,
  });

  const environment = EnvironmentStorage.getEnvironment();

  const generateQrCode = async (table) => {
    const qrCodeData = await QRCode.getDataUrl(table.qrcode);
    setState((prevState) => ({ ...prevState, qrcodeImage: qrCodeData }));
  };

  const downloadQrCode = (table) => {
    QRCode.downloadQRCodeImage(`qrcode-${table.code}.png`, table.qrcode);
  };

  const editTable = async () => {
    const { id, name, code } = state?.selectedTable;
    const value = { name, code };
    const response = await EnvironmentsAPI.putTablesEnvironment(
      environment.id,
      value,
      id
    );
    const enabledCode = response.getCode();
    if (enabledCode === 200) {
      if (loadTables) {
        await loadTables();
      }
      setState((prevState) => ({ ...prevState, open: false }));
    }
  };

  useEffect(() => {
    const checkActiveTables = async () => {
      const { id } = environment;
      const response = await EnvironmentsAPI.getConfigurationsModuleTables(id);
      const { table } = response.getData([]);

      if (loadTables) {
        await loadTables();
      }

      setState((prevState) => ({
        ...prevState,
        visible: table?.active,
        loading: false,
      }));
    };

    setState({ loading: true });
    checkActiveTables();
  }, []);

  const openDrawer = (table) => {
    generateQrCode(table);

    setState((prevState) => ({
      ...prevState,
      open: true,
      selectedTable: table,
    }));
  };

  const { loading, open, qrcodeImage, selectedTable } = state;

  if (loading) {
    return <Loading fullContent={true} />;
  }

  return (
    <div>
      <>
        {tables?.length === 0 ? (
          <Empty>
            <Icon name="table-cells" size="4x" />
            <p>Nenhuma mesa cadastrada</p>
            <span>
              Atualmente, o sistema não possui nenhuma mesa registrada.
            </span>
          </Empty>
        ) : (
          <div className={styles.groupContainer}>
            {tables?.map((table) => (
              <div className={styles.group} key={table.id}>
                <div className={styles.header}>
                  <div className="d-flex align-center">
                    <div className={styles.icon}>
                      <Icon name="table-cells" size="large" />
                    </div>
                    <hr className={styles.verticalDivider} />
                    <p className={styles.title}>
                      {table.name || "Nome não cadastrado"}
                    </p>
                    <div
                      className={styles.edit}
                      onClick={() => openDrawer(table)}
                    >
                      <Icon name="pen" size="large" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </>
      <Drawer
        visible={open}
        closeInFade={false}
        title={"Editar Mesa"}
        onClose={() =>
          setState((prevState) => ({ ...prevState, open: !prevState.open }))
        }
        footer={
          <Button
            disabled={!selectedTable?.name}
            design="primary"
            className="w-100"
            onClick={editTable}
          >
            Salvar Alteração
          </Button>
        }
      >
        <Input
          floatLabel="Nome da mesa"
          design="two"
          value={selectedTable?.name}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              selectedTable: {
                ...prevState.selectedTable,
                name: e.target.value,
              },
            }))
          }
          className="mt-15"
        />
        <div className={styles.qrcode}>
          <Label>QrCode</Label>
          <div className={styles.qrcodeContainer}>
            <img
              src={qrcodeImage}
              className={`${styles["img-fluid"]} ${styles.mobile}`}
              alt="Integrações"
              id="qrcode-image"
            />
            <Button
              design="primary"
              onClick={() => downloadQrCode(selectedTable)}
              className={"w-100"}
            >
              Salvar QR Code
            </Button>
          </div>
        </div>
      </Drawer>
    </div>
  );
}
